var axios = require('axios')
/**
 * @Params : filter + search
 * @Method : get
 */
axios.getOrderList = function (params, cancel, success, callBackError) {
  this.get(process.env.prefix_order + '/orders' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getOrderDetail = function (uuid, success, callBackError) {
  this.get(process.env.prefix_order + '/orders/' + uuid + '?show_all=true').then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getOrderDetailForProcessAction = function (uuid,params, success, callBackError) {
  if (params.hasOwnProperty('status') && params.status == 2) {
    params.force_resend = 1
  }
  this.put(process.env.prefix_order + '/orders/' + uuid,params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.resendMailOrder = function (params, success, callBackError) {
  this.post(process.env.prefix_order + '/orders/resend-order-confirmation', params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.printOrderDetail = function (uuid, success, callBackError) {
  this.get(process.env.prefix_order + '/print-order/' + uuid,{
    responseType: 'arraybuffer',
    headers: {
      'Accept': 'application/pdf'
    }}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getListOrderStatus = function (success, callBackError) {
  this.get(process.env.prefix_order + '/order-status-list').then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.listEmailTemplate = function (success, callBackError) {
  this.get(process.env.prefix_notification + '/email-template').then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getEmailTemplateByUuid = function (uuid, success, callBackError) {
  this.get(process.env.prefix_notification + '/email-template/'+uuid).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.sendEmailTemplate = function (data, success, callBackError) {
  this.post(process.env.prefix_notification + '/email-template',data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getDeliveryReceiptTemplate = function (params, success, callBackError) {
  this.post(process.env.prefix_notification + '/delivery-receipt-template', params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getBlacklistList = function (params, cancel, success, callBackError) {
  this.get(process.env.prefix_order + '/blacklists' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createBlacklist = function (params, success, callBackError){
  this.post(process.env.prefix_order+'/blacklists', params)
    .then(response => {
      success(response);
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.removeBlackList = function (params, success, callBackError) {
  this.delete(process.env.prefix_order + '/blacklists/'+params.uuid).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.exportOrders = function (params, success, callBackError) {
  this.get(process.env.prefix_order + '/export-orders' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getListCSV = function (params, success, callBackError) {
  this.get(process.env.prefix_order + '/export/contactless-curbside')
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.downloadCSV = function (params, success, callBackError) {
  this.get(process.env.prefix_order + '/export/contactless-curbside/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/Order.js